(() => {
    'use strict';

    const cartReq = { credentials: 'same-origin', cache: 'no-store' };

    // 触发购物车更新事件，展示折后价
    function refreshCartDrawerUi () {
        const drawer = document.querySelector('cart-drawer-items');
        if (drawer && typeof drawer.onCartUpdate === 'function') {
            drawer.onCartUpdate();
        }
    }

    async function removeDiscount () {
        try {
            const updateRes = await fetch('/cart/update.js', {
                method: 'POST',
                ...cartReq,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify({ discount: '' }),
            });
            const data = await updateRes.json();

            // Shopify 常把失败放在 HTTP 状态或 JSON 的 status/description 里，仍可能 resolve，必须校验
            if (!updateRes.ok) {
                return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'ironman-private',
                    cartData: data,
                });
            }

            refreshCartDrawerUi();
        } catch {
            // 网络或 Cart API 异常
        }
    }

    removeDiscount();
})();